import {
  ROLE_ADMIN,
  ROLE_ANAESTHETIST,
  ROLE_SECRETARY_ANAESTHETIST,
  ROLE_SURGEON_SECRETARY,
  normalizeRole,
} from '@/utils/roles'

export const roleRoutes = {
  [ROLE_SURGEON_SECRETARY]: { name: 'surgeon-secretary-surgeon-secretary-dashboard-page' },
  [ROLE_ANAESTHETIST]: { name: 'anaesthetist-anaesthetist-dashboard-page' },
  [ROLE_SECRETARY_ANAESTHETIST]: { name: 'secretary-anesthetist-secretary-anaesthetist-dashboard-page' },
  [ROLE_ADMIN]: { name: 'admin-admin-dashboard-page' },
}

export const resolveRoleRedirect = role => {
  const normalized = normalizeRole(role)
  
  return roleRoutes[normalized] ?? '/'
}
